import { render, staticRenderFns } from "./BasketGroup.vue?vue&type=template&id=1612a5c2&scoped=true"
import script from "./BasketGroup.vue?vue&type=script&lang=js"
export * from "./BasketGroup.vue?vue&type=script&lang=js"
import style0 from "./BasketGroup.vue?vue&type=style&index=0&id=1612a5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612a5c2",
  null
  
)

export default component.exports